import { VEHICLE_USER_TYPE_NUM } from 'constants/vehicle'
import AppUserTypes from 'store/actionTypes/appUser'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  info: {},
  error: null,
  subscriptionList: [],
  detailVehicleSharing: {},
  listVehicleSharingExtensions: {
    [VEHICLE_USER_TYPE_NUM.SHARER]: [],
    [VEHICLE_USER_TYPE_NUM.BENEFICIARY]: [],
    undefined: []
  },
  statusUsers: {},
  subscriptionAllowedPilots: [],
  notificationPush: {
    list: [],
    pagination: {}
  },
  notificationInApps: {
    list: [],
    pagination: {}
  }
}

const appUser = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AppUserTypes.GET_USER_SUBSCRIPTION_SUCCESS:
      return { ...state, subscriptionList: payload }
    case AppUserTypes.GET_SUBSCRIPTION_ALLOWED_PILOTS_SUCCESS:
      return {
        ...state,
        subscriptionAllowedPilots: payload?.subscriptionAllowedPilots
      }
    case AppUserTypes.GET_LIST_VEHICLES_SHARING_EXTENSION_SUCCESS:
      return {
        ...state,
        listVehicleSharingExtensions: {
          ...state.listVehicleSharingExtensions,
          [action?.meta?.params?.userType]: payload?.vehicleSharings?.items
        }
      }
    case AppUserTypes.GET_DETAIL_VEHICLES_SHARING_SUCCESS:
      return { ...state, detailVehicleSharing: payload }
    case AppUserTypes.GET_NOTIFICATION_PUSH_SUCCESS:
      return {
        ...state,
        notificationPush: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }

    case AppUserTypes.GET_NOTIFICATION_IN_APPS_SUCCESS:
      return {
        ...state,
        notificationInApps: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default appUser
